import React from 'react'
import {Icon, Label, Header, Segment, Grid, GridColumn, GridRow, Container, Button } from 'semantic-ui-react'
import Timer from './Timer'
import { connect } from 'react-redux'
import soundForVote from '../assets/000001.mp3'

const colorRight = 'green';
const colorFalse = 'teal';
const colorBase = 'blue'

class FormVotation extends React.Component {
   
    constructor(props) {
        super(props)
        this.state = {
            starting_time: null,
            msToAnswer: props.msToAnswer,
            jump:props.jump,
            isRunning:true,
            hasVoted:false
        }
    }

    componentDidMount() {
        this.setState({ starting_time: Date.now() })
    }
    
    onTimerFinished = () => {
        this.setState({isRunning:false});
        this.props.handleVote(0);
    }

    handleAnswer = (result) =>{
    }

    voted = (vote) =>{
        this.setState({hasVoted:true});
        this.props.handleVote(vote);
    }

    vote1 = (e)  =>{
      this.voted(1);
    }

    vote2 = (e)  =>{
        this.voted(0);
    }
  
    render() {
        const {msToAnswer, hasVoted} = this.state

        return (
                <Segment style={{ maxWidth: '800px', margin: 'auto' }}>
                    <Label color='purple' ribbon>{"Votazione"}</Label>
                    <div style={{ textAlign: 'center' }}>
                        <Header as='h2' style={{ fontWeight: 'normal' }}>'VOTA'</Header>
                        {hasVoted?<audio ref="audio_tag" src={soundForVote} autoPlay/>:""}
                        <Grid centered celled>
                            <GridRow >
                               <GridColumn centered width={8}>
                               <Container textAlign='center'>
                               {!hasVoted?
                                <Button fluid color={'blue'}    value='A' onClick={this.vote1}>
                                    <Icon name='thumbs up' size='huge'/>
                                    </Button>
                                :
                                <Button fluid color={'blue'} disabled>
                                    <Icon name='thumbs up' size='huge'/>
                                    </Button>
                               }
                                </Container>
                               </GridColumn>
                               <GridColumn centered width={8}>
                               {!hasVoted?
                               <Button fluid color={'red'} value='B' onClick={this.vote2}>
                                    <Icon name='thumbs down' size='huge'/>
                                </Button>
                                :
                                <Button fluid  color={'red'} disabled>
                                <Icon name='thumbs down' size='huge'/>
                                </Button>
                                }
                                </GridColumn>
                            </GridRow>
                        </Grid>
                        <Timer  ms={msToAnswer} bar={false} isReady={true} isRunning={this.state.isRunning} handleAnswer={this.props.handleAnswer} onTimerFinished ={this.onTimerFinished}  />
                    </div>
                    <Timer  ms={msToAnswer} isReady={true} isRunning={this.state.isRunning} bar={true}  handleAnswer={this.props.handleAnswer} onTimerFinished ={this.onTimerFinished}/>
                </Segment>
        )
    }

}

const mapStateToProps = (state, { isLogged }) => ({
    state : state, 
    user: state.user,
    isLogged,
    question:state.game?state.game.question:undefined,
})

const mapDispatchToProps = (dispatch, { socket }) => ({

})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(FormVotation)


// WEBPACK FOOTER //
// ./src/components/FormVotation.js